import React from 'react';
import { StructuredModal } from '../StructuredModal/StructuredModal';
import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { CART_TEST_ID } from './Cart.const';
import { DASHBOARD_LOGIN_LINK } from 'components/App/Routes/Routes';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { onModalContactSalesClick } from 'utils/ContactSalesUtils';

export interface ICartModalsProps {
  hasUrlActionError: boolean;
  errorModalDismissed: boolean;
  setErrorModalDismissed: (isErrorModalDismissed: boolean) => void;
  hasDcsError: boolean | undefined;
  isDuplicateLeadErrorModalOpen: boolean;
  setIsDuplicateLeadErrorModalOpen: (isDuplicateLeadErrorModalOpen: boolean) => void;
  isDuplicateAccountErrorModalOpen: boolean;
  setIsDuplicateAccountErrorModalOpen: (isDuplicateAccountErrorModalOpen: boolean) => void;
  isOtpContactSalesModalOpen: boolean;
  setIsOtpContactSalesModalOpen: (isOtpContactSalesModalOpen: boolean) => void;
  isClaimedOtpAccountModalOpen: boolean;
  setIsClaimedOtpAccountModalOpen: (isClaimedOtpAccountModalOpen: boolean) => void;
}

export const CartModals: React.FC<ICartModalsProps> = ({
  hasUrlActionError,
  errorModalDismissed,
  setErrorModalDismissed,
  hasDcsError,
  isDuplicateLeadErrorModalOpen,
  setIsDuplicateLeadErrorModalOpen,
  isDuplicateAccountErrorModalOpen,
  setIsDuplicateAccountErrorModalOpen,
  isOtpContactSalesModalOpen,
  setIsOtpContactSalesModalOpen,
  isClaimedOtpAccountModalOpen,
  setIsClaimedOtpAccountModalOpen,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <>
      <StructuredModal
        isOpen={hasUrlActionError && !errorModalDismissed}
        onRequestClose={() => setErrorModalDismissed(true)}
        title={t('something-went-wrong-title')}
        description={t('something-went-wrong-blurb')}
        actions={[
          {
            label: t('back'),
            variant: LinkVariant.SECONDARY,
            action: () => setErrorModalDismissed(true),
          },
        ]}
        testId={CART_TEST_ID.urlActionModal}
      />
      <StructuredModal
        isOpen={!!hasDcsError}
        shouldCloseOnEsc
        title={t('something-went-wrong-title')}
        description={t('something-went-wrong-blurb')}
        onRequestClose={() => history.goBack()}
        actions={[
          {
            label: t('back'),
            variant: LinkVariant.SECONDARY,
            action: () => {
              history.goBack();
            },
          },
        ]}
        testId={CART_TEST_ID.networkErrorModal}
      />
      <StructuredModal
        isOpen={isDuplicateLeadErrorModalOpen}
        shouldCloseOnEsc
        title={t('otp.errors.duplicateLead.title')}
        onRequestClose={() => setIsDuplicateLeadErrorModalOpen(false)}
        description={t('otp.errors.duplicateLead.modalSubtitle')}
        actions={[
          {
            label: t('close'),
            variant: LinkVariant.SECONDARY,
            action: () => setIsDuplicateLeadErrorModalOpen(false),
          },
          {
            label: t('contact-sales'),
            variant: LinkVariant.PRIMARY,
            action: onModalContactSalesClick,
          },
        ]}
        testId={CART_TEST_ID.duplicateLeadModal}
      />
      <StructuredModal
        isOpen={isDuplicateAccountErrorModalOpen}
        shouldCloseOnEsc
        title={t('otp.errors.duplicateAccount.modalTitle')}
        onRequestClose={() => setIsDuplicateAccountErrorModalOpen(false)}
        description={t('otp.errors.duplicateAccount.modalSubtitle')}
        actions={[
          {
            label: t('signin'),
            variant: LinkVariant.SECONDARY,
            action: () => window.location.assign(DASHBOARD_LOGIN_LINK),
          },
          {
            label: t('contact-sales'),
            variant: LinkVariant.PRIMARY,
            action: onModalContactSalesClick,
          },
        ]}
        testId={CART_TEST_ID.duplicateAccountModal}
      />
      <StructuredModal
        isOpen={isOtpContactSalesModalOpen}
        shouldCloseOnEsc
        title={t('otp.unsuccessful.title')}
        description={t('otp.unsuccessful.modal-subtitle')}
        onRequestClose={() => setIsOtpContactSalesModalOpen(false)}
        actions={[
          {
            label: t('close'),
            variant: LinkVariant.SECONDARY,
            action: () => setIsOtpContactSalesModalOpen(false),
          },
          {
            label: t('contact-sales'),
            variant: LinkVariant.PRIMARY,
            action: onModalContactSalesClick,
          },
        ]}
        testId={CART_TEST_ID.otpContactSalesModal}
      />
      <StructuredModal
        isOpen={isClaimedOtpAccountModalOpen}
        shouldCloseOnEsc
        title={t('otp.claimedOtpAccount.title')}
        description={t('otp.claimedOtpAccount.subtitle')}
        onRequestClose={() => setIsClaimedOtpAccountModalOpen(false)}
        actions={[
          {
            label: t('close'),
            variant: LinkVariant.SECONDARY,
            action: () => setIsClaimedOtpAccountModalOpen(false),
          },
          {
            label: t('signin'),
            variant: LinkVariant.PRIMARY,
            action: () => window.location.assign(DASHBOARD_LOGIN_LINK),
          },
        ]}
        testId={CART_TEST_ID.claimedOtpAccountModal}
      />
    </>
  );
};
